import { FerryGoogleProvider } from "./google";
import appConfig from "@/configs/app-config";

/**
 * Ferry Analytics Service
 * Tüm provider'ları yönetir (Google, Insider, Segmentify vb.)
 */
export class FerryAnalyticsService {
  constructor() {
    this.providers = [];

    // Google Analytics
    if (appConfig.THIRD_PARTY_OPTIONS.GOOGLE.ANALYTICS.ACTIVE) {
      this.providers.push(new FerryGoogleProvider());
    }

    // Diğer provider'lar (ileride eklenecek)
    // if (appConfig.THIRD_PARTY_OPTIONS.INSIDER.ACTIVE) {
    //   this.providers.push(new FerryInsiderProvider());
    // }
    // if (appConfig.THIRD_PARTY_OPTIONS.SEGMENTIFY.ACTIVE) {
    //   this.providers.push(new FerrySegmentifyProvider());
    // }
  }

  /**
   * Event'i tüm aktif provider'lara gönderir
   * @param {string} event - Event tipi
   * @param {object} data - Event verisi
   */
  track(event, data) {
    this.providers.forEach((provider) => {
      try {
        provider.track(event, data);
      } catch (error) {
        console.error(`Ferry Analytics Provider Error:`, error);
      }
    });
  }
}

export const ferryService = new FerryAnalyticsService();

